/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeNewAccountInformationPage() {
  customValidationInit(false);
  aspControlValidationInit();

  $(document).tooltip();
}
